import { NumericFilterOption } from '../types';
import { NumericEntry } from '../../components';

export const config: NumericFilterOption = {
  id: 'omicsExplorer.filters.cosmicMinimumCount',
  title: {
    id: 'omicsExplorer.filters.cosmicMinimumCount',
    defaultMessage: 'COSMIC Minimum Count',
  },
  content: NumericEntry,
  injectedProps: {
    searchKey: 'cosmicSampleCount',
    numericEntryOption: {
      id: 'omicsExplorer.filters.cosmicMinimumCount',
      searchValue: '',
      valuePostfix: ':gte',
      placeholderIntlLabel: {
        id: 'omicsExplorer.filters.cosmicMinimumCount.placeholderLabel',
        defaultMessage: 'Count',
      },
    },
  },
};
